import React, { useEffect, useState } from "react";

const dateFormatter = new Intl.DateTimeFormat("hu-HU", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
});

export default function ResultsCard(props) {
    let { item } = props;

    const [coming_soon, setComingSoon] = useState();
    const [releaseDate, setReleaseDate] = useState();

    const getBookTypeIcon = (book) => {
        if (book.type == 1) {
            return "/images/icon/new-e-book.svg";
        } else if (book.type == 2) {
            return "/images/icon/new-audiobook.svg";
        }
    };

    useEffect(() => {
        setComingSoon(new Date(item.release_date) > new Date())
        setReleaseDate(new Date(item.release_date))
    }, [item])

    return (
        <a href={item.url}>
            <li className="results__item">
                <img className="results__img" src={item.cover} alt="book" href={item.url} />

                <div className="results__info">
                    <h5>{item.title}</h5>

                    <span className="results__authors">
                        {item.authors.map((author, index) => (
                            <span 
                                key={index} 
                                className="results__author"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.location.href = author.url;
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                {author.name}
                                {index < item.authors.length - 1 ? ", " : ""}
                            </span>
                        ))}
                    </span>

                    <div className="results__cost">
                        {getBookTypeIcon(item) && (<img src={getBookTypeIcon(item)} height="16px" />)}

                        <div className="results__price">
                            {item.discount?.new_price ? (
                                <span style={{ fontWeight: "400" }}>
                                    <del>{window.Dibook.language.formatCurrency(item.price)}</del>
                                </span>
                            ) : null}
                            <span>
                                {coming_soon ? 
                                    'kb. ' + dateFormatter.format(releaseDate) : 
                                    window.Dibook.language.formatCurrency(item.discount?.new_price ?? 0 != 0 ? item.discount?.new_price : item.price)
                                }
                            </span>
                            {(!coming_soon && item.point > 0) && <span className="results__point">
                                {item.point} pont
                            </span>}
                        </div>
                    </div>
                </div>
            </li>
        </a>
    );
}
